jQuery(document).ready(function($){

    function wm_close_modal($dialog) {
        let video = $dialog.find('video');
        if (video.length) {
            if (!video[0].paused) {
                video[0].pause();
            }
        }

        let iframe = $dialog.find('iframe');
        if (iframe.length) {
            iframe = iframe[0].contentWindow;
            let vidFunc = 'pauseVideo';
            iframe.postMessage(
                '{"event":"command","func":"' + vidFunc + '","args":""}',
                "*"
            );
        }

        $dialog[0].close();
    }

    $('[data-modal-close]').click(function() {
        let $parent = $(this).closest('dialog');

        if (!$parent) {
            return;
        }

        wm_close_modal($parent);
    });

    $('dialog').click(function(event) {
        if (event.target !== this) {
            return;
        }

        wm_close_modal($(this));
    });

    $('dialog').on('close', function() {
        wm_close_modal($(this));
    });

    $('a[href^="#modal-menu"]').click(function(event) {
        event.preventDefault();

        let slug = $(this).attr('href');
        let $modal = $(slug);
        let $parent = $(this).closest('dialog');

        if (!$modal.length) {
            return;
        }

        $parent[0].close();

        $modal[0].showModal();
    });

});
